export const UPDATE_LIFESTYLE = '@OXD/UPDATE_LIFESTYLE'
export const UPDATE_ANON_LIFESTYLE = '@OXD/UPDATE_ANON_LIFESTYLE'

export const LIFESTYLE_UPDATE_REQUEST = '@OXD/LIFESTYLE_UPDATE_REQUEST'
export const LIFESTYLE_UPDATE_SUCCESS = '@OXD/LIFESTYLE_UPDATE_SUCCESS'
export const LIFESTYLE_UPDATE_FAILURE = '@OXD/LIFESTYLE_UPDATE_FAILURE'

export const GET_LIFESTYLE_REQUEST = '@OXD/GET_LIFESTYLE_REQUEST'
export const GET_LIFESTYLE_SUCCESS = '@OXD/GET_LIFESTYLE_SUCCESS'
export const GET_LIFESTYLE_FAILURE = '@OXD/GET_LIFESTYLE_FAILURE'
